import Model from '@models/Model'
import Person from '@models/Person'

class TrainingCenter extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'name',
        'training_center_group_id',
        'country_id',
        'state',
        'adhoc_location',
        'created_at',
        'updated_at',
      ],
      dateKeys: [
        'created_at',
        'updated_at',
      ],
      relationships: {
        current_paul: { collection: false, model: Person },
      },
    })
  }
}

export default TrainingCenter
